import React, { useCallback, useLayoutEffect } from 'react';
import { Image } from 'react-native';
import Animated from 'react-native-reanimated';
import { useAppDispatch } from 'store/hooks';
import { AppView, ButtonGroup } from 'design-system';
import Button, { HEIGHT, HEIGHT_PLUS_PADDING } from 'design-system/Button';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useStyles from 'hooks/useStyles';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import { savePotsOnboardingState } from 'features/pots/actions';
import { getPeriodFromRRule } from 'features/pots/utils';
import createStyleSheets from 'utils/createStyleSheets';
const aiSavingsImg = require('../../img/autosave_ai_savings.png');
const AutosaveEnableAISavings = withAnimatedNavigationHeader(({ route, scrollHandler, navigation }) => {
    const { collectionFrequency } = route.params;
    const dispatch = useAppDispatch();
    const styles = useStyles(styleSet);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING + HEIGHT + rem(8), paddingHorizontalStyle);
    const word = getPeriodFromRRule(collectionFrequency.rrule) === 'Monthly' ? 'month' : 'week';
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton articlesKey={HELP_ARTICLES_KEY.AUTOSAVE_ONBOARDING}/>,
        });
    }, []);
    const handleEnable = useCallback(() => {
        dispatch(savePotsOnboardingState({ automated: true, contributionAmount: null }));
        navigation.navigate('AutosaveChooseRoundupContributions', { collectionFrequency });
    }, [collectionFrequency]);
    const handleNotNow = useCallback(() => {
        dispatch(savePotsOnboardingState({ automated: null }));
        navigation.navigate('AutosaveChooseCustomContributions', {
            collectionFrequency,
        });
    }, [collectionFrequency]);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <ScreenInfoHeader title="Let us save for you" subTitle={`We analyse your spending and set aside the right amount automatically. It changes ${word} to ${word}, and if money's tight, we’ll skip a collection entirely.`}/>
          <Image source={aiSavingsImg} style={styles.img}/>
        </Animated.ScrollView>
        <ButtonGroup type="floating">
          <Button title="Not now" brandReversed onPress={handleNotNow}/>
          <Button title="Enable AI savings" brand onPress={handleEnable}/>
        </ButtonGroup>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styleSet = createStyleSheets(() => ({
    img: {
        width: rem(200),
        marginTop: '20%',
        height: rem(200),
        alignSelf: 'center',
    },
}));
export default AutosaveEnableAISavings;
